import {http} from '../service/ajax';
// var zzurl="http://113.105.85.170:3004/";
var zzurl="https://wx.wkzq.com.cn/";
export function zzreq(action,paramStr) {
 if(!paramStr){
   paramStr="";
 }   
 return http({
  url: zzurl+'reqxml?action='+action+paramStr,
  method: 'GET'
 });
}

export function httpget(url,paramStr) {
  if(!paramStr){
    paramStr="";
  }   
  return http({
   url: url+paramStr,
   method: 'GET'
  });
 }